import React from 'react';
import LegalPageLayout from '../../components/legal/LegalPageLayout';

export const KvkkPage = () => {
  return (
    <LegalPageLayout title="KVKK Aydınlatma Metni" enTitle="KVKK Privacy Notice" updatedAt="11 Ağustos 2026">
      <p className="legal-intro">
        Bu metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") madde 10 uyarınca,
        Martinci İmza Yönetim Portalı ("Martinci", "Hizmet") tarafından işlenen kişisel verileriniz
        hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.
      </p>

      <h2>1. Veri Sorumlusu</h2>
      <p>
        KVKK kapsamında veri sorumlusu, "Martinci İmza Yönetim Portalı" ticari adıyla faaliyet
        gösteren <strong>Utku Tamer Göktaş</strong>'tır (Vergi Kimlik No: 4060564940, Göztepe Vergi
        Dairesi, Fenerbahçe Mah. İğrip Sk. No: 13 İç Kapı No: 1, Kadıköy/İstanbul). Kişisel
        verilerinizle ilgili taleplerinizi <a href="mailto:destek@martinci.com">destek@martinci.com</a>{' '}
        adresine iletebilirsiniz.
      </p>

      <h2>2. İşlenen Kişisel Veri Kategorileri</h2>
      <p>Hizmeti kullanımınız kapsamında aşağıdaki kişisel veri kategorileri işlenmektedir:</p>
      <ul>
        <li><strong>Kimlik ve iletişim bilgileri:</strong> ad, soyad, e-posta adresi, organizasyonunuzun size ait olarak sisteme kaydettiği unvan, telefon ve adres bilgileri (imza şablonlarında kullanılan alanlar).</li>
        <li><strong>Hesap bilgileri:</strong> şifrenizin şifrelenmiş (hash'lenmiş) hâli, kullanıcı rolü, organizasyon üyeliği.</li>
        <li><strong>Dizin verisi:</strong> organizasyonunuzun Microsoft 365 veya Google Workspace bağlantısı üzerinden çekilen personel dizini bilgileri (ad, e-posta, unvan, grup üyeliği) — yalnızca organizasyon yöneticinizin bu bağlantıyı kurması hâlinde ve e-posta imzası oluşturma amacıyla.</li>
        <li><strong>İşlem ve log kayıtları:</strong> giriş zamanları, IP adresi, hizmet kullanım kayıtları (güvenlik ve hizmetin işleyişi amacıyla).</li>
        <li><strong>Fatura bilgileri:</strong> fatura e-posta adresi. Kart bilgileriniz Martinci sunucularına hiçbir şekilde ulaşmaz; ödeme doğrudan PAYTR'nin güvenli altyapısı üzerinden alınır.</li>
      </ul>

      <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
      <ul>
        <li>Hizmete kayıt olmanızı ve hesabınızı yönetmenizi sağlamak,</li>
        <li>Organizasyonunuz adına e-posta imza şablonlarının oluşturulması, personel dizinine göre eşleştirilmesi ve otomatik dağıtılması,</li>
        <li>Ödeme işlemlerinin PAYTR aracılığıyla gerçekleştirilmesi ve faturalandırma,</li>
        <li>Hizmetin güvenliğinin sağlanması, kötüye kullanımın önlenmesi,</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi ve talep hâlinde yetkili kurumlarla paylaşım.</li>
      </ul>

      <h2>4. Kişisel Verilerin İşlenmesinin Hukuki Sebebi</h2>
      <p>
        Kişisel verileriniz, KVKK madde 5/2 kapsamında; bir sözleşmenin kurulması veya ifasıyla
        doğrudan ilgili olması, hukuki yükümlülüğün yerine getirilmesi ve veri sorumlusunun meşru
        menfaati hukuki sebeplerine dayanılarak işlenmektedir.
      </p>

      <h2>5. Kişisel Verilerin Aktarıldığı Taraflar</h2>
      <p>Kişisel verileriniz, hizmetin işleyişi için gerekli ölçüde aşağıdaki taraflarla paylaşılabilir:</p>
      <ul>
        <li><strong>Microsoft 365 / Google Workspace:</strong> organizasyonunuzun bağladığı dizin sağlayıcısı, e-posta imzasının doğru şekilde dağıtılabilmesi için.</li>
        <li><strong>PAYTR:</strong> ödeme işlemlerinin gerçekleştirilmesi için (kart verileri Martinci'ye hiç ulaşmaz).</li>
        <li>Barındırma (hosting) ve altyapı sağlayıcıları, yalnızca teknik altyapının işletilmesi amacıyla.</li>
        <li>Yasal olarak yetkili kamu kurum ve kuruluşları, talep hâlinde.</li>
      </ul>

      <h2>6. Kişisel Verilerin Toplanma Yöntemi</h2>
      <p>
        Kişisel verileriniz; kayıt formunu doldurmanız, hizmeti kullanmanız ve organizasyon
        yöneticinizin sizi sisteme eklemesi veya bir dizin bağlantısı kurması yoluyla, elektronik
        ortamda otomatik yollarla toplanmaktadır.
      </p>

      <h2>7. Saklama Süresi</h2>
      <p>
        Kişisel verileriniz, hesabınız aktif olduğu sürece ve ilgili mevzuatta öngörülen zamanaşımı
        süreleri boyunca saklanır. Hesap kapatma talebinizin ardından veriler, yasal saklama
        yükümlülükleri dışında makul bir süre içinde silinir veya anonimleştirilir.
      </p>

      <h2>8. İlgili Kişi Olarak Haklarınız</h2>
      <p>KVKK madde 11 uyarınca aşağıdaki haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verinizin işlenip işlenmediğini öğrenme,</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
        <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
        <li>Yurt içinde/yurt dışında aktarıldığı üçüncü kişileri bilme,</li>
        <li>Eksik/yanlış işlenmişse düzeltilmesini isteme,</li>
        <li>KVKK'da öngörülen şartlar çerçevesinde silinmesini/yok edilmesini isteme,</li>
        <li>Yapılan işlemlerin, verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
        <li>Otomatik sistemlerle analiz sonucu aleyhinize bir sonucun ortaya çıkmasına itiraz etme,</li>
        <li>Kanuna aykırı işlenme sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme.</li>
      </ul>
      <p>
        Bu haklarınızı kullanmak için <a href="mailto:destek@martinci.com">destek@martinci.com</a>{' '}
        adresine yazılı olarak başvurabilirsiniz.
      </p>
    </LegalPageLayout>
  );
};

export default KvkkPage;
